import React from 'react';
import { Button } from 'common-ui';
import { handleMiniCartClickEvents, handleRedirectionClick } from '../../../../utils/cart/miniCartUtils';

type ViewCartProps = {
  totalLineItem: number;
  redirectLink: string;
  onClose: () => void;
  isUK: boolean;
};

const ViewCart = ({ totalLineItem, redirectLink, onClose, isUK }: ViewCartProps) => {
  const viewCartText = isUK ? 'basket' : 'cart';

  return (
    <Button
      kind="secondary"
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        handleRedirectionClick(e, redirectLink, onClose);
        handleMiniCartClickEvents('viewMiniCartClick');
      }}
      className="view-basket"
    >
      VIEW {viewCartText.toUpperCase()} ({totalLineItem} ITEM{totalLineItem > 1 ? 'S' : ''})
    </Button>
  );
};

export default ViewCart;
